import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["render", "as", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React from 'react';
import { RichText } from '../rich-text/rich-text';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * If there is no as value explitly defined then we should use the render value
 */
var getValidAs = function getValidAs(render, as) {
  var validAs = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'];
  var invalidRender = ['display-1', 'display-2', 'display-3', 'display-4', 'display-5', 'display-6'];

  if (!invalidRender.includes(render) && !as) {
    return render;
  }

  if (as && validAs.includes("".concat(as))) {
    return as;
  }

  return 'p';
};

export var Title = function Title(_ref) {
  var render = _ref.render,
      as = _ref.as,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var Component = getValidAs(render, as);
  return /*#__PURE__*/_jsx(RichText, _objectSpread({
    as: Component,
    className: classNames('d-inline', _defineProperty({}, render, render && as), className)
  }, rest));
};